import * as React from 'react';
import { defaultSearchResultLimit } from 'common/constants';
import AutoComplete from 'components/Common/autoComplete';
import './emailManagementHeader.scss';
import  { getValue } from 'utils/functionUtils';
import { configurationsStore } from 'utils/MobxDataManager/singletons';

interface IEmailManagementProps {
    isDisabled: boolean;
}

interface IEmailManagementState {
    matchedEmail: string;
    matchFound: boolean;
}

export class EmailManagementHeader extends React.Component<IEmailManagementProps, IEmailManagementState> {
    constructor(props: IEmailManagementProps) {
        super(props);

        this.handleSearchEmails = this.handleSearchEmails.bind(this);
        this.handleSubmitClick = this.handleSubmitClick.bind(this);
        this.handleClearMatchedEmail = this.handleClearMatchedEmail.bind(this);
        this.handleSetMatchedEmail = this.handleSetMatchedEmail.bind(this);

        this.state = Object.assign({}, this.state, {
            matchedEmail: '',
            matchFound: true
        });
    }

    render(): React.ReactNode {
        return (
            <div className="email-management-header">
                <h3 className="email-management-header__heading">Email Management</h3>
                <p className="email-management-header__explanation">
                    Enter manager&apos;s email to exclude them from all email notifications. You will be able to resume
                    notifications to a manager at the appropriate time in the cycle. Email addresses will carry over
                    to next cycle.
                </p>
                <div className="email-management-header__selection">
                    <div className="email-management-header__search">
                        <AutoComplete
                            id="emailSearch"
                            placeholder={this.setPlaceHolderText()}
                            search={this.handleSearchEmails}
                            resultLimit={defaultSearchResultLimit}
                            onChangeInput={this.handleClearMatchedEmail}
                            onSuggestionSelected={this.handleSetMatchedEmail}
                            onClearSearch={this.handleClearMatchedEmail}
                            getSelectedValue={getValue}
                            getRenderedSuggestionText={getValue}
                            initialValue={''}
                            disableInput={this.props.isDisabled}
                        />
                    </div>
                    <button
                        className="email-management-header__save-btn pxl-btn pxl-btn--primary"
                        onClick={this.handleSubmitClick}
                        disabled={this.props.isDisabled}
                    >
                        Submit
                    </button>
                </div>
                {this.renderErrorMessage()}
            </div>
        );
    }

    private renderErrorMessage(): React.ReactNode {
        if (!this.state.matchFound) {
            return (
                <div className="email-management-header__error-message">Manager not found</div>
            );
        }
        return null;
    }

    private async handleSearchEmails(
        searchText: string,
        resultLimit: number): Promise<string[]> {
        const results = await configurationsStore.getSuggestedEmails(searchText, resultLimit);
        if (!results?.length) {
            this.setState({ matchedEmail: '', matchFound: false });
        }
        return results ?? [];
    }

    private setPlaceHolderText(): string {
        return 'Search emails';
    }

    private handleSetMatchedEmail(email: string): void {
        this.setState({ matchedEmail: email, matchFound: true });
    }

    private handleClearMatchedEmail(): void {
        this.setState({ matchedEmail: '', matchFound: true });
    }

    private async handleSubmitClick(): Promise<void> {
        await configurationsStore.disableEmailNotification(this.state.matchedEmail);
        const element =
            document?.querySelector('.email-management-header .autocomplete-input .icon-cancel') as HTMLElement;
        if (element) {
            element.click();
        }

        this.handleClearMatchedEmail();
    }
}